import * as React from 'react';
import {resourcesHelper} from "@ferry/portal-core";

interface IProps {
}

interface IState {
    showAlert: boolean
}

export class FailedPaymentMessage extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);

        this.state = {
            showAlert: true
        }

        this.closeAlert = this.closeAlert.bind(this);
    }

    public render(): React.ReactNode {
        return this.state.showAlert && (
            <div className="page-validation" role="alert">
                <div className="page-validation-alert">
                    <img className="page-validation-alert-icon" alt="Alert icon" src={`/${resourcesHelper.THEME_PATH}/img/alert-red.svg`}/>
                </div>
                <div className="page-validation-message">
                    <p className="page-validation-message-top">
                        Oops! Something went wrong...
                    </p>
                    <p className="page-validation-message-bottom">
                        We accept most major credit and debit cards that use the 3D verification process
                    </p>
                    <p className="page-validation-message-bottom">
                        The payment card will need to be registered at the same address as the {resourcesHelper.THEME_NAME} policy
                    </p>
                    <p className="page-validation-message-bottom">
                        We don’t accept commercial/business cards, Diners Club, Citi Bank, American Express or prepaid cards
                    </p>
                </div>
                <div className="page-validation-close">
                    <button
                        type="button"
                        className="btn page-validation-close-button"
                        onClick={this.closeAlert}
                    />
                </div>
            </div>
        )
    }

    private closeAlert(): void {
        this.setState({
            showAlert: false
        })
    }
}
